var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFileGif(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "22px",
    viewBox: "0 0 19 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/z_File/GIF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/z_File/GIF",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/GIF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,6 C11,6 11,0 11,0 L2,0 C2,0 2,21.8835449 2,22 L17,22 C17,22 17,6 17,6 L11,6 Z",
    id: "Fill-37",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#AAAAAA",
    points: "12 0 12 5 17 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#E2AF10",
    points: "0 20 19 20 19 11 0 11"
  }), /*#__PURE__*/React.createElement("text", {
    id: "GIF",
    fontFamily: "Montserrat-ExtraBold, Montserrat",
    fontSize: 7,
    fontWeight: 600,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3.3715,
    y: 18
  }, "GIF"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileGif);
export default __webpack_public_path__ + "static/media/icon-file-gif.2a3dd9a84b61ed6840151cc1383d1eea.svg";
export { ForwardRef as ReactComponent };